import React from 'react';
import { StarIcon, QuoteIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { testimonials } from '../data/content';
function Stars() {
  return <div className="flex gap-0.5" data-id="element-179" data-mp="3fz5s296i04m2">
      {Array.from({
      length: 5
    }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-yellow-brand text-yellow-brand" data-id="element-180" data-mp="3b0ucrixfp1wg" data-mpi={i} />)}
    </div>;
}
function Card({
  quote,
  name
}: {
  quote: string;
  name: string;
}) {
  const initial = name.charAt(0);
  return <figure className="mx-3 flex w-80 shrink-0 flex-col rounded-2xl border border-beige bg-white p-6 shadow-sm" data-id="element-181" data-mp="31zmqy0c3ttj9">
      <QuoteIcon className="h-6 w-6 text-green-soft" data-id="element-182" data-mp="2x1kywpwpajvn" />
      <blockquote className="mt-3 flex-1 text-[15px] leading-relaxed text-[#3A463A]" data-id="element-183" data-mp="2s1qbwxg1qefv">
        “{quote}”
      </blockquote>
      <figcaption className="mt-4 flex items-center gap-3 border-t border-beige pt-4" data-id="element-184" data-mp="v9ooxkq6li2z">
        <span className="flex h-10 w-10 items-center justify-center rounded-full bg-green-brand font-display font-bold text-white" data-id="element-185" data-mp="q9tz7ki56yji">
          {initial}
        </span>
        <div data-id="element-186" data-mp="h8aytf4m6trr">
          <span className="block text-sm font-bold text-green-deep" data-id="element-187" data-mp="m51ei1cibncn">{name}</span>
          <Stars data-id="element-188" data-mp="m2ygov544pxd" />
        </div>
      </figcaption>
    </figure>;
}
export function Testimonials() {
  const row1 = testimonials.slice(0, 5);
  const row2 = testimonials.slice(5);
  return <section className="w-full overflow-hidden bg-cream py-16 sm:py-24" data-id="element-189" data-mp="c8y11zc7g2ae">
      <div className="mx-auto max-w-6xl px-5" data-id="element-190" data-mp="zxr3menc18dz">
        <SectionHeading eyebrow="Testimonios" title="Miles de mamás ya tienen su guía" subtitle="+5.718 descargas de mamás que resolvieron sus viandas." data-id="element-191" data-mp="14vj0zo6qxmpk" />
        <div className="mt-6 flex items-center justify-center gap-2" data-id="element-192" data-mp="v5ps4uxznlp0">
          <Stars data-id="element-193" data-mp="v3wl3ejgqzgh" />
          <span className="text-sm font-bold text-[#4A5748]" data-id="element-194" data-mp="v3d0fq2fhwyr">
            Valoración 5/5 en base a la experiencia de nuestras compradoras
          </span>
        </div>
      </div>

      {/* Marquee rows */}
      <div className="mt-12 space-y-5" data-id="element-195" data-mp="1xi0npbdbfxz6">
        <div className="group flex w-max animate-marquee hover:[animation-play-state:paused]" data-id="element-196" data-mp="1xgxx74jwnxjs">
          {[...row1, ...row1].map((t, i) => <Card key={`r1-${i}`} {...t} data-id="element-197" data-mp="1sgtj1l6gzewq" data-mpi={i} />)}
        </div>
        <div className="group flex w-max animate-marquee hover:[animation-play-state:paused]" style={{
        animationDirection: 'reverse'
      }} data-id="element-198" data-mp="1ofzq2de679wz">
          {[...row2, ...row2].map((t, i) => <Card key={`r2-${i}`} {...t} data-id="element-199" data-mp="1ekfxo0ytetcz" data-mpi={i} />)}
        </div>
      </div>
    </section>;
}